<template>
  <div class="py-2 px-2">
    <notifications-list :notifications="notifications" :projects-map="projectsMap" :elements-map="planningElementsById"></notifications-list>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import useHomeUserStore from '@/stores/home-user';
  import useNotificationsStore from '@/stores/notifications';
  import NotificationsList from '@/components/Notifications/NotificationsList.vue';

  export default {
    components: {
      NotificationsList,
    },
    props: {
      notifications: { type: Array, required: true },
    },
    computed: {
      projectsMap() {
        const projectsMap = new Map();
        this.plannings.forEach((planning) => { projectsMap.set(planning.id, planning.toProject()); });
        return projectsMap;
      },
      accountNotificationsById() {
        return useNotificationsStore().byId;
      },
      ...mapState(useHomeUserStore, ['planningElementsById', 'plannings']),
    },
    watch: {
      accountNotificationsById: {
        handler(newVal) { // watch notifications seen elsewhere in the store
          this.notifications.forEach((notif) => {
            if (newVal[notif.id]) notif.seen_at = newVal[notif.id].seen_at;
          });
        },
        immediate: true,
      },
    },
  };
</script>
